import React, { useState } from 'react';
import styled from 'styled-components';
import CommunityIconbtnpage from './CommunityIconbtnpage';
import { Link, useHistory } from 'react-router-dom';
import server from 'server/serverController2';
import appInfoContainer from '../../../../auth/appInfoContainer';
import DotButton from 'components/presenters/button/DotButton';
import BottomModal from 'components/presenters/modal/BottomModal';
import { replaceTextURLToLink } from 'utils/utils.js';
import { useSelector } from 'react-redux';
const type = {
  free_topic: '자유글',
  review: '후기',
  greeting: '가입인사',
  info: '정보',
};

export default function CommunityPhotoUploadDetail({
  likedeldataSubmit,
  likedataSubmit,
  background,
  border,
  borderwidth,
  borderline,
  margintop,
  comnum,
  link,
  item,
  currentPostNo,
  isLikeAnimation
}) {
  
  const userInfo = useSelector((state) => {
    return state['userInfo'];
  })

  const history = useHistory();

  const [visible, setVisible] = useState(false);
  const [dataList, setDataList] = useState([])

  //날짜 출력 폼 형태 시간 포함
  function getDateTimeType(date, second) {
    function checkZero(checkString) {
      return checkString.toString().length === 1
        ? '0' + checkString
        : checkString;
    }
    var temp =
      `${checkZero(date.getFullYear())}/${checkZero(
        date.getMonth() + 1,
      )}/${checkZero(date.getDate())},` +
      ` ${checkZero(date.getHours())}:${checkZero(date.getMinutes())} ${
        second ? ':' + checkZero(date.getSeconds()) : ''
      } `;
    return temp;
  }

  const deletePostRequest = async (param) => {
    try {
      const deleteResult = await server.deleteRequestData(`campaigns/posts/${param.no}`);
      if(deleteResult['success'] === 0) {
        return;
      }
      history.goBack();
    } catch (error) {
      if(process.env.NODE_ENV === 'development') {
        console.log(error);
      }
    }
  }

  const handleModalState = () => {
    setDataList([
      {type: 'redirect', text: '글수정', path: `/campaign/community/post/${item.no}/edit`, style: {}},
      {type: 'callback', text: '삭제', callback: deletePostRequest, callbackParam: item, style: {color: '#DE0000'}}
    ])
    setVisible(true);
  }

  const date = getDateTimeType(new Date(item.create_date), false);
  let content = '';
  if(item?.content)
  {
    content = replaceTextURLToLink(item.content);
  }
  
  return (
    <WriteDoneInner
      border={border}
      background={background}
      style={{ background: item.pin ? '#ffefce' : '#fff' }}
    >
      <UserWrite>
        <UserWriteBar>
          <Link to={`/task/friend/${item?.user_no}/list`}>
            <UserImg>
              <Images
                src={
                  appInfoContainer.imagePath +
                  '/user_profile_img/' +
                  item.profile_img
                }
              />
            </UserImg>
          </Link>
          <UserWriteDay>
            <UserNameZone>
              <UserName>{item.nickname}</UserName>
            </UserNameZone>
            <When>
              <span>{date}</span>
            </When>
          </UserWriteDay>
        </UserWriteBar>
        <BtDot>
          <FreeWtBt>{type[item.post_type]}</FreeWtBt>
          {item.user_no === userInfo['id'] ?(
            <DotButton onClick={(e) => handleModalState(e, null, 'post')} style={{marginLeft: 'calc(100vw * (15/375))'}}/>
          ) :null}
        </BtDot>
      </UserWrite>
      {
        (link)
        ?(
          <Link to={link} sytle={{ width: '100%' }}>
            <UserWriteCont>{content}</UserWriteCont>
            {item.img_attachment
            ? item.img_attachment.map((value) => {
                return (
                  <UploadImg>
                    <img
                      alt={'user campaign post upload file'}
                      src={
                        appInfoContainer.imagePath + '/campaign_post_img/' + value
                      }
                    />
                  </UploadImg>
                );
              })
            : null}
          </Link>
        )
        :(
          <span sytle={{ width: '100%' }}>
            <UserWriteCont>{content}</UserWriteCont>
            {item.img_attachment
            ? item.img_attachment.map((value, index) => {
                return (
                  <UploadImg key={`community-img-no-${index}`}>
                    <img
                      alt={'user campaign post upload file'}
                      src={
                        appInfoContainer.imagePath + '/campaign_post_img/' + value
                      }
                    />
                  </UploadImg>
                );
              })
            : null}
          </span>
        )

      }
      
      <CommunityIconbtnpage
        borderwidth={borderwidth}
        borderline={borderline}
        margintop={margintop}
        comnum={comnum}
        length={item.total_comment}
        heartnum={item.total_like}
        no={item.no}
        campaign_no={item.campaign_no}
        likedataSubmit={likedataSubmit}
        likedeldataSubmit={likedeldataSubmit}
        item={item}
        currentPostNo={currentPostNo}
        isLikeAnimation={isLikeAnimation}
      />
      <BottomModal visible={visible} setVisible={setVisible} dataList={dataList}/>
    </WriteDoneInner>
  );
}

const Images = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
const WriteDoneInner = styled.div`
  // margin-top: calc(100vw * (14 / 375));
  width: 100%;
  border-radius: calc(100vw * (5 / 375));
  // border: solid calc(100vw*(1/375)) #eaeaea;
  background-color: #ffffff;
  padding: calc(100vw * (8 / 375)) calc(100vw * (12 / 375))
    calc(100vw * (5 / 375)) calc(100vw * (10 / 375));
  border: ${({ border }) => border};
  background-color: ${({ background }) => background};
`;
const UserImg = styled.span`
  display: block;
  width: calc(100vw * (42 / 375));
  height: calc(100vw * (42 / 375));
  border-radius: 50%;
  border: solid calc(100vw * (1 / 375)) #c6c6c6;
  overflow: hidden;
`;
const UserNameZone = styled.li`
  display: flex;
  align-items: center;
  margin-bottom: calc(100vw * (3.9 / 375));
`;
const UserWriteDay = styled.ul`
  margin-left: calc(100vw * (10 / 375));
`;
const UserName = styled.em`
  display: block;
  font-size: calc(100vw * (14 / 375));
  font-weight: bold;
`;
const UserWrite = styled.ul`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: calc(100vw * (10 / 375));
`;
const UserWriteBar = styled.li`
  display: flex;
  align-items: center;
`;

const FreeWtBt = styled.span`
  width: calc(100vw * (74 / 375));
  height: calc(100vw * (26 / 375));
  border-radius: calc(100vw * (5 / 375));
  background-color: #1d1d1d;
  font-size: calc(100vw * (12 / 375));
  font-weight: 500;
  line-height: calc(100vw * (26 / 375));
  text-align: center;
  color: #ffffff;
`; 
const BtDot = styled.li`
  display: flex;
  align-items: center;
`;
const When = styled.li`
  font-size: calc(100vw * (12 / 375));
  color: #989898;

  & > span {
    color: #989898;
  }
`;

const UserWriteCont = styled.p`
  font-size: calc(100vw * (14 / 375));
  line-height: 1.5;
  color: #1d1d1d;
  white-space: pre-wrap;
  word-break: break-all;
  a {
    color: #0000ff;
  }
`;

const UploadImg = styled.span`
  width: 100%;
  margin-top: calc(100vw * (8 / 375));
`;
